import { Nullable } from '../../types/common'
import { parseHTML, replaceNodeChildren } from '../../utils/dom'
import { delay, $el } from '../../utils/utils'
import { RecentlyViewed } from '../recently-viewed/recently-viewed'
import { SidebarComponent } from '../../components/sidebar/sidebar'

const { Shopify }: any = window

export class QuickView extends SidebarComponent {
  cache: object = {}
  rendered: Nullable<HTMLElement>
  content: Nullable<HTMLElement>

  requestProductFromUrl(url: string, id: string): void {
    if (!this.cache[url]) {
      this.rendered = $el(
        `.shopify-section [data-quick-view-product-id="${id}"]`,
      )

      if (this.rendered && this.rendered.dataset.quickViewProductUrl === url) {
        this.cache[url] = delay(0).then(() => this.rendered)
      } else {
        this.cache[url] = fetch(url)
          .then(response => response.text())
          .then(responseText => parseHTML(responseText))
          .catch(() => console.log('error in quick view'))
      }
    }
  }

  handleContentScroll = (): void => {
    const isScrolled = this.content ? this.content.scrollTop > 0 : false
    this.toggleAttribute('header-shadow-visible', isScrolled)
  }

  openAndRenderProductByUrl = async (url: string): Promise<void> => {
    if (this.cache[url]) {
      let html

      await this.cache[url].then(result => {
        html = result
      })

      if (this.rendered) {
        this.rendered.replaceChildren()
      }

      if (this.isOpen) {
        await this.hide()
      }
      this.setProductFromHTML(html)
      await this.open()

      Shopify?.PaymentButton?.init()
    }
  }

  setProductFromHTML(html: Document): void {
    if (this.dataset.targetId) {
      const target = $el(`#${this.dataset.targetId}`, html)

      if (target) {
        RecentlyViewed.updateProductsInLocalStorage(
          target.dataset.productHandle,
        )

        const targetClass = target.getAttribute('class') || ''
        const clonedTarget = target.cloneNode(true)

        this.element.setAttribute('class', targetClass)
        this.element.replaceChildren(...clonedTarget.childNodes)
        this.content = $el('[data-quick-view-content]', this.element)

        this.addListener(this.content, 'scroll', this.handleContentScroll)
      }
    }
  }

  resetProduct(): void {
    if (this.content) {
      this.removeListener(this.content, 'scroll', this.handleContentScroll)

      if (this.rendered) {
        replaceNodeChildren(this.rendered, this.content)
      }

      this.content = null
    }

    this.element.replaceChildren()
  }
}
